import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useLanguage, waLink } from "../i18n";

const FloatingWhatsApp = () => {
  const { t } = useLanguage();
  return (
    <motion.a
      data-testid="floating-whatsapp-button"
      href={waLink(t.waGeneric)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      initial={{ opacity: 0, scale: 0, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 3.4, duration: 0.55, type: "spring", bounce: 0.5 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.94 }}
      className="group fixed bottom-6 right-6 z-50 flex items-center gap-0 rounded-full bg-[#25D366] p-4 text-white shadow-2xl shadow-[#25D366]/40 transition-shadow duration-300"
    >
      <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366]/40" />
      <MessageCircle size={26} strokeWidth={2.3} />
      <span className="max-w-0 overflow-hidden whitespace-nowrap text-sm font-bold transition-all duration-500 group-hover:ml-2.5 group-hover:max-w-[120px]">
        {t.floating}
      </span>
    </motion.a>
  );
};

export default FloatingWhatsApp;
